// SP: ヘッダー直下のタブバーがスクロールでヘッダーの裏に隠れたら、
// ヘッダーをロゴ表示からシゴト/マガジンメニュー表示に切り替える（切り替え自体はCSSでフェード）
const main = () => {
    const header = document.querySelector('.c-layouts-header[data-sp-tabs]');
    const tabs = document.querySelector('.c-layouts-header-tabs');
    if (!header || !tabs || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(([entry]) => {
        // タブバーが表示されていない（PC）ときは何もしない
        if (entry.rootBounds === null || !tabs.offsetParent) return;
        const isHidden = !entry.isIntersecting && entry.boundingClientRect.top < header.offsetHeight;
        header.toggleAttribute('data-sp-tabs-hidden', isHidden);
    }, {
        // 固定ヘッダーの下端を境界にする
        rootMargin: `-${header.offsetHeight}px 0px 0px 0px`,
    });
    observer.observe(tabs);
}

export default main;
